<template>
  <div class="news-container">
    <div class="banner-section">
      <div class="swiper-container">
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide v-for="(item, index) in slides" :key="index">
            <div
              class="news-card"
              @click.stop="onClickSwiper(item)"
            >
              <img class="news-card-image" :src="item.pic" alt />
              <div class="news-card-content">
                <span class="news-title">{{ item.title }}</span>
                <div class="news-info">
                  <img
                    class="news-icon"
                    src="@assets/images/time_icon.png"
                    alt
                  />
                  <span class="news-date">{{
                    item.date
                  }}</span>
                  <img
                    class="news-icon location-icon"
                    src="@assets/images/postion_icon.png"
                    alt
                  />
                  <span class="news-date">{{
                    item.location
                  }}</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <img
            class="swiper-button-prev"
            src="@assets/images/arrow_left.png"
            slot="button-prev"
            alt
          />
          <img
            class="swiper-button-next"
            src="@assets/images/arrow_right.png"
            slot="button-next"
            alt
          />
        </swiper>
      </div>
    </div>
    <div class="news-section">
      <div class="news-left">
        <div
          v-for="(item, index) in newsLeft"
          class="news-item"
          :key="'left' + index"
          @click.stop="onClickSwiper(item)"
        >
          <div class="news-item-header">
            <img class="news-icon" src="@assets/images/postion_icon.png" alt />
            <span class="news-address">{{
              item.address
            }}</span>
            <span class="news-time">{{
              item.time
            }}</span>
            <div class="news-line-right"></div>
          </div>
          <div class="news-item-content">
            <div class="flex-column">
            <span class="news-content-text">{{item.contenttop}}</span>
            <span class="news-content-text">{{item.contentdown}}</span>
            </div>
            <img class="news-content-image" :src="item.pic" alt />
          </div>
        </div>
      </div>

      <div class="timeline-container">
        <div class="timeline-ball">
          <div class="timeline-dot"></div>
        </div>
        <div class="timeline-line"></div>
      </div>

      <div class="news-right">
        <div
          v-for="(item, index) in newsRight"
          class="news-item"
          :key="'right' + index"
          @click.stop="onClickSwiper(item)"
        >
          <div class="news-item-header">
            <div class="news-line-left"></div>
            <span class="news-time">{{ item.time }}</span>
            <img
              class="news-icon location-icon-right"
              src="@assets/images/postion_icon.png"
              alt
            />
            <span class="news-address">{{
              item.address
            }}</span>
          </div>
          <div class="news-item-content">
            <div class="flex-column">
            <span class="news-content-text">{{item.contenttop}}</span>
            <span class="news-content-text">{{item.contentdown}}</span>
            </div>

            <img class="news-content-image" :src="item.pic" alt />
          </div>
        </div>
      </div>

      <!-- 移动端新闻列表 -->
      <div class="mobile-news-list">
        <div
          v-for="(item, index) in mobileNewsItems"
          class="news-item"
          :key="'mobile' + index"
          @click.stop="onClickSwiper(item)"
        >
          <!-- <div class="news-item-header">
            <img class="news-icon" src="@assets/images/postion_icon.png" alt />
            <span class="news-address">{{
              item.address
            }}</span>
            <span class="news-time">{{
              item.time
            }}</span>
          </div> -->
          <div class="news-item-content">
            <span class="news-content-text">{{
              item.content
            }}</span>
            <img class="news-content-image" :src="item.pic" alt />
          </div>
          <div class="news-item-header">
            <img class="news-icon" src="@assets/images/postion_icon.png" alt />
            <span class="news-address">{{
              item.address
            }}</span>
            <span class="news-time">{{
              item.time
            }}</span>
          </div>

        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// import { computed } from "vue";

export default {
  name: "NewCenter",
  comments: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        // 核心配置
        effect: "coverflow",
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        initialSlide: 2,

        // Coverflow 特效参数
        coverflowEffect: {
          rotate: 0, // 幻灯片旋转角度
          stretch: 50, // 幻灯片拉伸间距
          depth: 200, // 幻灯片深度偏移
          modifier: 1, // 效果乘数
          slideShadows: true, // 启用幻灯片阴影
        },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "swiper-button-disabled", // 覆盖禁用状态类名
        },
        // 添加断点配置，针对不同屏幕宽度设置不同的参数
        breakpoints: {
          // 当窗口宽度小于等于768px时
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: "slide", // 在移动端使用简单的滑动效果
            centeredSlides: true,
            loop: true,
            coverflowEffect: {
              rotate: 0,
              stretch: 0, // 移动端不使用拉伸
              depth: 0, // 移动端不使用深度
              modifier: 1,
              slideShadows: false, // 移动端禁用阴影
            },
          },
          // PC端使用默认配置，恢复大于768px时的效果
          769: {
            slidesPerView: "auto",
            spaceBetween: 0,
            effect: "coverflow",
            centeredSlides: true,
            loop: true,
            coverflowEffect: {
              rotate: 0,
              stretch: 50,
              depth: 200,
              modifier: 1,
              slideShadows: true,
            },
          }
        }
      },
       // 将数据初始化为空数组，在created钩子中填充
      slides: [],
      newsLeft: [],
      newsRight: [],
      mobileNewsItems: []
      
    };
  },
  created() {
    this.updateData();
  },
  methods: {
    updateData() {
      // 轮播数据
      this.slides = [
        {
          pic: require("@assets/images/NewsCenter_pic5.png"),
          title:this.$t('newsCenter.title1'),
          date: this.$t('newsCenter.date1'),
          location: this.$t('newsCenter.location1'),
        },
        {
          pic: require("@assets/images/NewsCenter_pic6.png"),
          title:this.$t('newsCenter.title2'),
          date: this.$t('newsCenter.date2'),
          location: this.$t('newsCenter.location2'),
        },
        {
          pic: require("@assets/images/NewsCenter_pic1.png"),
          title:this.$t('newsCenter.title3'),
          date: this.$t('newsCenter.date3'),
          location: this.$t('newsCenter.location3'),
        },
        {
          pic: require("@assets/images/NewsCenter_pic3.png"),
          title:this.$t('newsCenter.title4'),
          date: this.$t('newsCenter.date4'),
          location: this.$t('newsCenter.location4'),
        },
        {
          pic: require("@assets/images/NewsCenter_pic4.png"),
          title:this.$t('newsCenter.title5'),
          date: this.$t('newsCenter.date5'),
          location: this.$t('newsCenter.location5'),
        },
      ];

  this.newsLeft = [
          {
        address: this.$t('newsCenter.adress7'),
        time:this.$t('newsCenter.time7'),
        contenttop:this.$t('newsCenter.content7top'),
        contentdown:this.$t('newsCenter.content7down'),
        pic: require("@assets/images/NewsCenter_pic7.png"),
      },
      {
        address: this.$t('newsCenter.adress1'),
        time:this.$t('newsCenter.time1'),
        contenttop:this.$t('newsCenter.content1top'),
        contentdown:this.$t('newsCenter.content1down'),
        pic: require("@assets/images/NewsCenter_pic2.png"),
      },
      {
        address: this.$t('newsCenter.adress2'),
        time:this.$t('newsCenter.time2'),
        contenttop:this.$t('newsCenter.content2top'),
        contentdown:this.$t('newsCenter.content2down'),
        pic: require("@assets/images/NewsCenter_pic4.png"),
      },
      {
        address: this.$t('newsCenter.adress3'),
        time:this.$t('newsCenter.time3'),
        contenttop:this.$t('newsCenter.content3top'),
        contentdown:this.$t('newsCenter.content3down'),
        pic: require("@assets/images/NewsCenter_pic6.png"),
      },
    ];
  this.newsRight = [
      {
        address: this.$t('newsCenter.adress4'),
        time:this.$t('newsCenter.time4'),
        contenttop:this.$t('newsCenter.content4top'),
        contentdown:this.$t('newsCenter.content4down'),
        pic: require("@assets/images/NewsCenter_pic1.png"),
      },
      {
        address: this.$t('newsCenter.adress5'),
        time:this.$t('newsCenter.time5'),
        contenttop:this.$t('newsCenter.content5top'),
        contentdown:this.$t('newsCenter.content5down'),
        pic: require("@assets/images/NewsCenter_pic3.png"),
      },
      {
        address: this.$t('newsCenter.adress6'),
        time:this.$t('newsCenter.time6'),
        contenttop:this.$t('newsCenter.content6top'),
        contentdown:this.$t('newsCenter.content6down'),
        pic: require("@assets/images/NewsCenter_pic5.png"),
      },
    ];
      
    // 为移动端创建合并的新闻列表，按时间顺序排列
    this.mergeMobileNewsItems();
    },
    
    mergeMobileNewsItems() {
    // 合并左右两侧新闻,[右边1,左边1,右边2,左边2...这样排列]
    const allNews = [];
    const maxLength = Math.max(this.newsLeft.length, this.newsRight.length);

    for (let i = 0; i < maxLength; i++) {
      // // 先添加右侧新闻项
      // if (i < this.newsRight.length) {
      //   allNews.push(this.newsRight[i]);
      // }
      // // 再添加左侧新闻项
      // if (i < this.newsLeft.length) {
      //   allNews.push(this.newsLeft[i]);
      // }

            // 先添加左侧新闻项
      if (i < this.newsLeft.length) {
        allNews.push(this.newsLeft[i]);
      }
      // 再添加右侧新闻项
      if (i < this.newsRight.length) {
        allNews.push(this.newsRight[i]);
      }
    }

    // 将交错排列后的新闻项赋值给移动端新闻数组
    this.mobileNewsItems = allNews;
    },

    onClickSwiper(item) {
      console.log(item);
      switch (item.pic) {
        case require("@assets/images/NewsCenter_pic7.png"):
          this.$router.push({ name: "newscenterdetails7" });
          break;
        case require("@assets/images/NewsCenter_pic5.png"):
          this.$router.push({ name: "newscenterdetails5" });
          break;
        case require("@assets/images/NewsCenter_pic6.png"):
          this.$router.push({ name: "newscenterdetails6" });
          break;
        case require("@assets/images/NewsCenter_pic1.png"):
          this.$router.push({ name: "newscenterdetails1" });
          break;
        case require("@assets/images/NewsCenter_pic3.png"):
          this.$router.push({ name: "newscenterdetails3" });
          break;
        case require("@assets/images/NewsCenter_pic4.png"):
          this.$router.push({ name: "newscenterdetails4" });
          break;
        case require("@assets/images/NewsCenter_pic2.png"):
          this.$router.push({ name: "newscenterdetails2" });
          break;
        default:
          console.log("No matching case for the given pic.");
      }
    },
  },
  watch: {
    '$i18n.locale'() {
      this.updateData();
    }
  }
 
};
</script>

<style lang="scss" scoped>
/* 主容器样式 */
.news-container {
  display: flex;
  flex-direction: column;
  
}

/* 轮播区域样式 */
.banner-section {
  width: 100%;
  height: 562px;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-container {
  width: 1340px;
}

/* 新闻卡片样式 */
.news-card {
  width: 418px;
  background: white;
  display: flex;
  flex-direction: column;
  min-height: 418px;
  cursor: pointer;
}

.news-card-image {
  width: 418px;
  height: 278px;
}

.news-card-content {
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 11px;
  padding-bottom: 27px;
}

.news-title {
  font-size: 24px;
  line-height: 32px;
  font-family: "OPPO-B";
  color: #000000;
}

.news-info {
  display: flex;
  align-items: center;
  margin-top: 19px;
}

.news-icon {
  width: 19px;
  height: 19px;
}

.location-icon {
  margin-left: 26px;
}

.news-date {
  font-size: 19px;
  line-height: 19px;
  font-family: "OPPO-R";
  color: #909399;
  margin-left: 8px;
}

/* 新闻列表区域样式 */
.news-section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 80px;
}
/* 左侧新闻样式 */
.news-left {
  display: flex;
  flex-direction: column;
  // margin-top: 156px;
  margin-top: -46px;

}
/* 右侧新闻样式 */
.news-right {
  // margin-top: -46px;
  margin-top: 156px;

}

.location-icon-right {
  margin-left: 20px;
}
.news-item {
  display: flex;
  flex-direction: column;
  margin-top: 132px;
  cursor: pointer;
}

.news-item-header {
  display: flex;
  align-items: center;
  align-self: flex-end;
}

.news-address {
  margin-left: 8px;
  font-family: "OPPO-R";
  font-size: 19px;
  line-height: 19px;
  color: #606266;
}

// 主页的时间字体
.timeandaddress
{
    color: #909399;

    font-family: "OPPO-R";
    font-size: 16px;
}

.news-time {
  margin-left: 8px;
  font-family: "OPPO-R";
  font-size: 19px;
  line-height: 19px;
  color: #606266;
}

.news-line-right {
  width: 20px;
  height: 2px;
  background: #e5e5e5;
  margin-left: 10px;
  margin-right: -29px;
}

.news-line-left {
  width: 20px;
  height: 2px;
  background: #e5e5e5;
  margin-right: 9px;
  margin-left: -29px;
}

.news-item-content {
  width: 573px;
  height: 220px;
  margin-top: 20px;
  padding-left: 20px;
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: #f8f8f8;
  
}

.news-content-text {
  font-size: 22px;
  line-height: 30px;
  font-family: "OPPO-M";
  color: #303133;
  width: 264px;
  
}

.news-content-image {
  width: 240px;
  height: 160px;
}

/* 时间线样式 */
.timeline-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 9px;
  margin-right: 9px;
  z-index: -1;
}

.timeline-ball {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-dot {
  width: 14px;
  height: 14px;
  background: black;
  border-radius: 50%;
}

.timeline-line {
  width: 6px;
  height: 1462px;
  background: #f8f8f8;
}



/* 轮播按钮样式 */
.swiper-button-prev,
.swiper-button-next {
  width: 44px;
  height: 44px;
  background: transparent;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-left: 2px solid #333;
  border-bottom: 2px solid #333;
}

/* 轮播项样式 */
.swiper-slide {
  width: 300px; /* 控制幻灯片宽度 */
  transition: all 0.3s;
}

/* 激活态幻灯片放大 */
.swiper-slide-active {
  transform: scale(1.1);
  z-index: 1;
}

/* 分页器样式 */
.swiper-pagination ::v-deep .swiper-pagination-bullet {
  background: #999;
  opacity: 0.6;
  width: 12px;
  height: 12px;
}

.swiper-pagination ::v-deep .swiper-pagination-bullet-active {
  background: #409eff;
  opacity: 1;
}

/* 禁用默认的灰色效果 */
.swiper-button-disabled {
  opacity: 1 !important;
}
.swiper-button-disabled::after {
  border-color: #ddd !important;
}

.swiper-slide {
  width: 418px !important;
  margin-right: 0px !important;
}

/* 移动端新闻列表 */
.mobile-news-list {
  display: none;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  /* 轮播区域移动端样式 */
  .banner-section {
    height: 320px;
    padding: 0;
    overflow: hidden;
  }

  .swiper-container {
    width: 100%;
  }

  /* 隐藏轮播左右切换按钮 */
  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .swiper-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .news-card {
    width: 100%;
    max-width: 320px;
    min-height: auto;
    height: 280px;
    margin: 0 auto;
  }

  .news-card-image {
    width: 100%;
    height: 180px;
    object-fit: cover;
    object-position: center;
  }
  
  .news-card-content {
    padding: 10px 15px;
  }

  .news-title {
    font-size: 16px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-info {
    margin-top: 10px;
  }

  .news-date {
    font-size: 12px;
  }

  .news-icon {
    width: 16px;
    height: 16px;
  }

  .location-icon {
    margin-left: 15px;
  }

  .swiper-slide {
    width: 100% !important;
    margin-right: 0 !important;
    transition: all 0.3s ease;
  }
  
  /* 不在移动端放大激活态幻灯片 */
  .swiper-slide-active {
    transform: none;
  }

  /* 新闻列表区域移动端样式 */
  .news-section {
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    position: relative;
    padding: 0 15px;
  }

  /* 隐藏PC版左右布局，显示移动版列表 */
  .news-left, .news-right {
    display: none;
  }

  .mobile-news-list {
    display: flex;
    margin-top: 0px;
    padding-bottom: 50px;
  }

  /* 时间轴移动端样式 */
  .timeline-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    margin: 0;
    width: auto;
    z-index: 0;
  }

  .timeline-line {
    height: 100%;
    width: 4px;
    position: relative;
    left: 0;
    transform: none;
  }

  .timeline-ball {
    display: none;
    position: sticky;
    top: 50px;
    margin-bottom: 0px;
  }

  .news-item {
    margin-top: 40px;
    width: 90%;
    position: relative;
    z-index: 1;
  }

  .news-item:first-child {
    margin-top: 60px;
  }

  .news-item-header {
    align-self: center;
    justify-content: left;
    margin-top: 10px;
    flex-wrap: wrap;
  }

  .news-item-content {
    width: 100%;
    height: auto;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-radius: 8px;
    padding: 15px;
  }

  .news-content-text {
    width: 100%;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-content-image {
    width: 100%;
    height: auto;
    max-height: 180px;
    object-fit: cover;
    border-radius: 4px;
  }

  /* 修改左右侧新闻样式以适应垂直布局 */
  .news-right .news-item-header, 
  .news-left .news-item-header,
  .mobile-news-list .news-item-header {
    flex-direction: row;
    width: 100%;
    justify-content: center;
    margin-bottom: 15px;
  }

  .news-line-right, .news-line-left {
    display: none;
  }

  .location-icon-right {
    margin-left: 8px;
  }

  .news-time {
    font-size: 18px;
    margin: 0 5px;
    font-weight: bold;
  }

  .news-address {
    font-size: 14px;
    text-align: center;
  }

  /* 移动端轮播控制按钮样式 */
  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    height: 30px;
    top: 45%;
    opacity: 0.8;
  }
}
</style>
